import type { ReactNode } from "react";
import * as stylex from "@stylexjs/stylex";
import {
  colors,
  fontSizes,
  spacing,
} from "@softmax/design-system/tokens.stylex";

export function PlayEpisodeResults({
  summary,
  children,
}: {
  readonly summary: string;
  readonly children: ReactNode;
}) {
  return (
    <>
      <p {...stylex.props(styles.resultSummary)}>{summary}</p>
      {children}
    </>
  );
}

const styles = stylex.create({
  resultSummary: {
    margin: 0,
    paddingBottom: spacing.space16,
    fontSize: fontSizes.small,
    lineHeight: "18px",
    color: colors.subtle,
  },
});
